document.addEventListener('DOMContentLoaded', function () {
    const collectionNavigation = document.querySelector('.collection-navigation');
    const collectionListSection = document.querySelector('.shopify-section--collection-list');
    const footerSection = document.querySelector('.shopify-section--footer');
    const radioContainer = document.querySelector('.collection-navigation__radio-options');

    // Your array of options.
    let optionsArray = [
        { value: 'all-products', text: 'Kategorie' },
        { value: 'bedurfnisse', text: 'Bedürfnis' },
    ];

      const pageSelected = document.querySelector(".collection-list__bullet-title-active");
    let pageSelectedCategoryName
    if(pageSelected){
        pageSelectedCategoryName = pageSelected.dataset.categoryName;
    }
    // Default selected option.
    let currentSelected =pageSelectedCategoryName;

    // Render radio options
   function renderRadioOptions() {
  radioContainer.innerHTML = '';
  optionsArray.forEach((option) => {
    // Container voor óf radio óf link
    const optionElement = document.createElement('div');
    optionElement.classList.add('collection-navigation__radio-option');
    if (option.text === pageSelectedCategoryName) {
      // === actieve categorie: render radio
      optionElement.classList.add('collection-navigation__radio-option-active');

      const label = document.createElement('label');
      label.classList.add('collection-navigation__radio-label');

      const radioInput = document.createElement('input');
      radioInput.type = 'radio';
      radioInput.name = 'collection-filter';
      radioInput.value = option.text;
      radioInput.classList.add('collection-navigation__radio-input');
      radioInput.checked = (option.text === currentSelected);

      const customRadio = document.createElement('span');

      const radioText = document.createElement('span');
      radioText.classList.add('collection-navigation__radio-text', 'p-xs');
      radioText.textContent = option.text;

      label.append(radioInput, customRadio, radioText);
      optionElement.append(label);

    } else {
      // === niet actief: render als link
      const link = document.createElement('a');
      // hangt af van hoe je slug-format wilt hebben, bv. lowercased, spaces > hyphens, etc.
      const slug = option.value.toLowerCase().replace(/\s+/g, '-');
      link.href = `/collections/${slug}`;
      link.classList.add('collection-navigation__list-item-url');
      link.innerHTML = `
        <span class="collection-navigation__list-item-dot"></span>
        <p class="p-xs">${option.text}</p>
      `;
      optionElement.append(link);
    }

    radioContainer.append(optionElement);
  });
}


    // Initialize radio options
    renderRadioOptions();

    // Adjust navigation position based on scroll.
    function checkScroll() {
        const collectionListRect = collectionListSection.getBoundingClientRect();
        const footerRect = footerSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        const isCollectionListOut = collectionListRect.bottom <= windowHeight * 0.5;
        const isFooterVisible = footerRect.top <= windowHeight;

        if (isCollectionListOut) {
            collectionNavigation.style.transform = 'translateY(0)';
        } else {
            collectionNavigation.style.transform = 'translateY(100%)';
        }
        if (isFooterVisible) {
            collectionNavigation.style.transform = 'translateY(100%)';
        }
    }
    window.addEventListener('scroll', checkScroll);
    checkScroll();

    // Container for dynamically generated anchors (for "category1").
    const anchorsContainer = document.querySelector('.collection-navigation__list-anchors');

    // Get all sections with the class 'custom-featured-collection-container'.
    const collectionSections = document.querySelectorAll('.custom-featured-collection-container');
    // Array to store the anchor tags for later use.
    const collectionAnchors = [];

    function renderAnchorTags() {
        anchorsContainer.innerHTML = '';
        collectionAnchors.length = 0;
        collectionSections.forEach((section) => {
            const collectionId = section.id;
            const collectionPurpose = section.getAttribute('data-collection-purpose') || 'Unnamed Collection';

            const listItem = document.createElement('div');
            listItem.classList.add('collection-navigation__list-item');

            const anchorTag = document.createElement('a');
            anchorTag.href = `#${collectionId}`;
            anchorTag.classList.add('scroll-to-collection');

            const dot = document.createElement('span');
            dot.classList.add('collection-navigation__list-item-dot');

            const collectionParagraph = document.createElement('p');
            collectionParagraph.classList.add('p-xs');
            collectionParagraph.textContent = collectionPurpose;

            anchorTag.appendChild(dot);
            anchorTag.appendChild(collectionParagraph);
            listItem.appendChild(anchorTag);
            anchorsContainer.appendChild(listItem);
            collectionAnchors.push(anchorTag);
        });

        // Add smooth scroll behavior for generated anchors.
        document.querySelectorAll('.scroll-to-collection').forEach((anchor) => {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();
                const targetId = anchor.getAttribute('href').substring(1);
                const targetSection = document.getElementById(targetId);
                const offset = 16;
                if (targetSection) {
                    const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - offset;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth',
                    });
                }
            });
        });

        let lastActiveIndex = -1;
        function updateActiveState() {
            const viewportHeight = window.innerHeight;
            let newActiveIndex = -1;
            collectionSections.forEach((section, index) => {
                const sectionRect = section.getBoundingClientRect();
                if (sectionRect.top <= viewportHeight * 0.5 && sectionRect.bottom >= viewportHeight * 0.5) {
                    if (newActiveIndex === -1) {
                        newActiveIndex = index;
                    }
                }
            });
            if (newActiveIndex !== -1 && newActiveIndex !== lastActiveIndex) {
                if (lastActiveIndex !== -1) {
                    collectionAnchors[lastActiveIndex].parentElement.classList.remove('collection-navigation__list-item-active');
                }
                collectionAnchors[newActiveIndex].parentElement.classList.add('collection-navigation__list-item-active');
                lastActiveIndex = newActiveIndex;
            }
        }
        window.addEventListener('scroll', updateActiveState);
        updateActiveState();
    }

    renderAnchorTags();


});
